const features = {
  activity: false,
}

export type FeatureName = keyof typeof features

export default features
